import { gql } from '@apollo/client';

export const fetchDueQuotesForHomePageInPPC = gql`
  query fetchDueQuotesForHomePageInPPC($searchOptions: ConnectionSearchOptions, $filterOptions: FilterOption) {
    quotes(searchOptions: $searchOptions, filterOptions: $filterOptions) {
      totalCount
      nodes {
        id
        transactionAccountId
        quoteNumber
        status
        expiryDate
        shipToObject {
          displayName
        }
        createdDate
        currency
        total
      }
    }
  }
`;
